import { useAtom } from 'jotai';
import { jotaiStore } from 'store';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Modal from './modal';
import { Button } from './button';

interface Props {
    isOpen?: boolean;
    setIsOpen?: (v: boolean) => void;
}
export const PlanLimitModal = ({ isOpen = false, setIsOpen }: Props) => {
    const [planLimitModal, setPlanLimitModal] = useAtom(
        jotaiStore.planLimitModal
    );
    const { t } = useTranslation();
    const navigate = useNavigate();

    const onClose = () => {
        setPlanLimitModal(false);
        if (setIsOpen) setIsOpen(false); // Close the modal before navigating
    };

    const handleTopUp = () => {
        setPlanLimitModal(false); // Close the modal before navigating
        if (setIsOpen) setIsOpen(false); // Close the modal before navigating
        navigate('/billing/addCredit'); // Update to the correct top-up page path
    };

    const canShowModal = !['/billing/payment', '/billing/addCredit'].includes(
        window.location.pathname
    );

    return (
        <Modal
            isOpen={canShowModal && (isOpen || planLimitModal)}
            onClose={onClose}
            size="small"
        >
            {/* Modal Heading */}
            <div className="flex flex-col items-center gap-4 p-4">
                <div className="flex gap-2 md:px-6 flex-row-reverse md:flex-row items-center w-full ">
                    <img
                        className="h-auto  w-1/6 "
                        src="/assets/images/startAssessment.png"
                        alt=""
                    />

                    <div className="flex  flex-col flex-grow gap-2">
                        <span className="font-semibold md:text-2xl text-primary-content">
                            {t('Plan Limit Reached')}
                        </span>
                    </div>
                </div>

                <span className="text-2xl font-semibold text-primary-content" />
                <p className="text-xl text-primary-content text-center">
                    {t(
                        'Oops! It appears you have reached your free assessment or interview limit. Please top up your account to continue.'
                    )}
                </p>

                {/* Actions */}
                <div className="flex items-center gap-4">
                    <Button
                        onClick={onClose}
                        variant="secondaryOutline"
                        className="px-6 py-2"
                    >
                        {t('Close')}
                    </Button>
                    <Button
                        onClick={handleTopUp}
                        variant="secondary"
                        className="px-6 py-2"
                    >
                        {t('Top Up Now')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
